var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIrmIconSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1791 6.64223V15.8424C22.1791 16.0707 21.9869 16.2744 21.7697 16.2744H4.26927C4.02865 16.2744 3.85993 16.0707 3.85993 15.8424V1.10795C3.85993 0.85492 4.0536 0.67749 4.26927 0.67749H10.9699C11.0916 0.67749 11.187 0.728405 11.2604 0.804005L13.1882 2.83133H21.7697C22.0103 2.83133 22.1791 3.03499 22.1791 3.28802V6.64223ZM19.4295 17.4522H2.97208C2.74384 17.4522 2.58379 17.259 2.58379 17.0424V4.06233H1.13805C0.984019 4.06233 0.845703 4.18905 0.845703 4.36976V19.0356C0.845703 19.1987 0.966205 19.3441 1.13805 19.3441H19.1371C19.2922 19.3441 19.4295 19.1987 19.4295 19.0356V17.4522ZM6.24349 13.9911L15.0104 13.9983L15.0072 13.9946L19.4205 13.9982L15.9097 9.86446L13.8075 12.5819L10.4196 8.59285L6.24349 13.9911Z",
    fill: "#6F7687"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrmIconSystem);
export default __webpack_public_path__ + "static/media/irm-icon-system.83e89ce0e671e92a229012b0a01e71ef.svg";
export { ForwardRef as ReactComponent };